export const SPREADSHEET_ACCEPT =
  'text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, .csv'

export const toCellString = (value: unknown): string => String(value ?? '').trim()

const isEmptyRow = (row: unknown[]): boolean => !Array.isArray(row) || row.every((cell) => toCellString(cell) === '')

/**
 * Reads the first sheet of a CSV/XLS/XLSX file as rows of cells, empty rows are dropped.
 * `raw` keeps CSV cells as text — without it values like "0001" are converted to numbers.
 */
export const readSpreadsheetRows = async (
  file: File,
  { raw = false }: { raw?: boolean } = {}
): Promise<unknown[][]> => {
  const buffer = await file.arrayBuffer()
  const xlsx = await import('@e965/xlsx')
  const workbook = xlsx.read(buffer, { type: 'array', raw })
  const worksheet = workbook.Sheets[workbook.SheetNames[0]]
  const rows = xlsx.utils.sheet_to_json<unknown[]>(worksheet, { header: 1, blankrows: false })

  return rows.filter((row) => !isEmptyRow(row))
}

const toCsvCell = (value: unknown): string => {
  const cell = String(value ?? '')

  return /[",\r\n]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell
}

export const rowsToCsv = (rows: unknown[][]): string => rows.map((row) => row.map(toCsvCell).join(',')).join('\r\n')
